import { useId, useMemo, useState } from "react";
import { keyBy } from "lodash";
import { useSnapshot } from "valtio";

import { siteGeometryStore } from "src/js/stores/siteGeometry/store";
import { mapStore } from "src/js/stores/map/store";

import { LayerTypeMapLayerProps } from "react-migration/layouts/map/Multilayer/types";
import { HoveredClusterInfo } from "react-migration/lib/map/layers/ClusteredViewportSearchMapLayer";
import { useSiteStages } from "react-migration/domains/sites/hooks/useSiteStages";
import { useMapLayer } from "react-migration/lib/map/useMapLayer";
import {
  SitesCluster,
  SitesClusteredViewportSearchMapLayer,
} from "react-migration/domains/sites/map/SitesClusteredViewportSearchMapLayer";

import { SITES_MAP_LAYER_ID } from "../constants";
import { useClusteredViewportSiteFilters } from "./useClusteredViewportSiteFilters";
import { SitesClusterTooltip } from "./SitesClusterTooltip";

export function SitesMapLayer({ visible, layer }: LayerTypeMapLayerProps) {
  const id = useId();
  const [hoveredClusterInfo, setHoveredClusterInfo] = useState<HoveredClusterInfo<SitesCluster> | null>(null);
  const { googleMap } = useSnapshot(mapStore);
  const { mapType } = useSnapshot(mapStore.settings);
  const { stages } = useSiteStages();
  const { changeCount: sitesDirtyCount } = useSnapshot(siteGeometryStore);
  const filters = useClusteredViewportSiteFilters();
  const stageLookup = useMemo(() => keyBy(stages, "_id"), [stages]);

  useMapLayer(
    () => ({
      layer: new SitesClusteredViewportSearchMapLayer({
        id: `${id}-${SITES_MAP_LAYER_ID}`,
        visible,
        googleMap,
        mapType,
        filters,
        stageLookup,
        sitesDirtyCount,
        skip: !filters.workspaces.length,
        onClusterHover: setHoveredClusterInfo,
        clusterEventProperties: {
          selectionLayerId: layer.id,
        },
      }),
      zOrder: Infinity,
    }),
    [id, visible, googleMap, mapType, filters, stageLookup, sitesDirtyCount, layer.id, setHoveredClusterInfo]
  );

  return <SitesClusterTooltip hoveredClusterInfo={hoveredClusterInfo} />;
}
